import React, { useEffect, useRef } from "react";
import { useModalMap } from "../../../../../common-deprecated/containers/ModalProvider";
import { aemLexusCommonModalMap } from "../../../../../common-deprecated/components/modals/aem/lexus/modals";
import * as ConfigurationHeaderStyles from "./active-filters/configuration-header/styles/ConfigurationHeaderContainerStyle";
import ModelResultsContainer from "./model-results/ModelResultsContainer";
import FilterSidebar from "./filters/FilterSidebar";
import StaticFilterBar from "./active-filters/top-bar/StaticFilterBar";
import useFixedFilterBar from "../../../../../shared-logic/features/filters/hooks/useFixedFilterBar";
import { FILTER_BAR_HEIGHT } from "./active-filters/top-bar/styles/StaticFilterBarStyles";
import FilterResultCount from "./active-filters/top-bar/FilterResultCount";
import ConfigurationHeaderContainer from "./active-filters/configuration-header/ConfigurationHeaderContainer";
import * as ModelResultStyles from "./model-results/styles/ModelResultStyles";
import useModelFilter from "../../hooks/useModelFilter";
import useStatus from "../../../../../common-deprecated/hooks/useStatus";
import { useModelFilterSelector } from "../../redux/store";
import { updateTrackingLayerVersioning } from "../../utils/tracking";
import useDisclaimerContent from "../../hooks/useDisclaimerContent";
import { IntegratedLegalBannerDisclaimer } from "../../../../shared-components/lexus/IntegratedLegalBannerDisclaimer";
import { SKIP_ID_FILTERS } from "../../utils/constants/constants";
import PromotionBanner from "./promotionBanner/PromotionBanner";
import { useBreakpoint } from "../../../../../common-deprecated/themes/common";

const ModelFilter = (): JSX.Element => {
    const commonSettings = useModelFilterSelector((state) => state.commonSettings);
    const isMobile = useBreakpoint("down", "md");

    const resultsContainerRef = useRef<HTMLDivElement>(null);
    const isFixed = useFixedFilterBar(resultsContainerRef, FILTER_BAR_HEIGHT);
    const promotionBannerConfig = useModelFilterSelector((state) => state.modelFilterSettings.promotionBannerConfig);
    const isValidPromoBannerConfig =
        promotionBannerConfig &&
        promotionBannerConfig.title &&
        promotionBannerConfig.description &&
        promotionBannerConfig.bannerUrl;

    useModelFilter();
    useModalMap(aemLexusCommonModalMap);
    useStatus(commonSettings, "Model Filter");
    useEffect(() => {
        updateTrackingLayerVersioning();
    }, []);

    const nlFinanceDisclaimerData = useDisclaimerContent();

    return (
        <>
            {isMobile && isValidPromoBannerConfig && <PromotionBanner promotionBannerConfig={promotionBannerConfig} />}
            <StaticFilterBar isFixed={isFixed} />

            <ConfigurationHeaderStyles.Viewport id={SKIP_ID_FILTERS}>
                <ConfigurationHeaderContainer />
            </ConfigurationHeaderStyles.Viewport>

            <ModelResultStyles.Container>
                {!isMobile && isValidPromoBannerConfig && (
                    <PromotionBanner promotionBannerConfig={promotionBannerConfig} />
                )}

                <ModelResultStyles.Header>
                    <FilterResultCount show={!isFixed} />
                </ModelResultStyles.Header>
                <ModelResultStyles.MainGrid>
                    <FilterSidebar />
                    <ModelResultsContainer />
                </ModelResultStyles.MainGrid>
            </ModelResultStyles.Container>
            {nlFinanceDisclaimerData && (
                <ModelResultStyles.LegalBannerContainer>
                    <IntegratedLegalBannerDisclaimer data={nlFinanceDisclaimerData} />
                </ModelResultStyles.LegalBannerContainer>
            )}
        </>
    );
};

export default ModelFilter;
